import styled from "@emotion/styled"
import Link from "next/link"
import {
  EmailIcon,
  EmailIconMobile,
  PhoneIcon,
  PhoneIconMobile,
} from "ui/icons"

import colors from "theme/colors"
import { Desktop, Mobile, NewText } from "ui"
import { extractProperty } from "utils"

const StyledContainer = styled.div`
  display: flex;
  height: 68px;
  ${(props) => props.theme.breakpoints.up("md")} {
    justify-content: flex-end;
    height: 74px;
  }
`
const StyledBackground = styled.div`
  display: flex;
  flex-direction: column;

  background: rgba(21, 62, 105, 0.12);
  width: 100%;
  gap: 4px;
  padding: 8px 16px 12px 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 32px;
    align-items: center;

    flex-direction: row;
    padding: 20px 40px;
    width: 795px;
  }
`

const StyledDataContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledData = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
  gap: 4px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 8px;
  }
`

type Props = {
  data: any
}

function ContactInfo({ data }: Props) {
  const contactInfoTitle = extractProperty(data, "contactInfoTitle")
  const email = extractProperty(data, "email")
  const phoneNumber = extractProperty(data, "phoneNumber")

  return (
    <StyledContainer>
      <StyledBackground>
        <NewText
          component="h2"
          color={colors.black}
          desktopFontSize={24}
          desktopLineHeight="150%"
          desktopFontWeight="500"
          mobileFontSize={16}
        >
          {contactInfoTitle}
        </NewText>
        <StyledDataContainer>
          <StyledData href={`mailto:${email[0]?.url}`} aria-label={`email:${email[0]?.name}`}>
            <Desktop>
              <EmailIcon />
            </Desktop>
            <Mobile>
              <EmailIconMobile />
            </Mobile>
            <NewText
              component="p"
              color={colors.blue}
              desktopFontSize={18}
              desktopLineHeight="24px"
              desktopFontWeight="400"
              mobileFontSize={14}
              mobileLineHeight="20px"
            >
              {email[0]?.name}
            </NewText>
          </StyledData>
          <StyledData href={`tel:${phoneNumber[0]?.url}`} aria-label={`phone:${phoneNumber[0]?.name}`}>
            <Desktop>
              <PhoneIcon />
            </Desktop>
            <Mobile>
              <PhoneIconMobile />
            </Mobile>
            <NewText
              component="p"
              color={colors.blue}
              desktopFontSize={18}
              desktopLineHeight="24px"
              desktopFontWeight="400"
              mobileFontSize={14}
              mobileLineHeight="20px"
            >
              {phoneNumber[0]?.name}
            </NewText>
          </StyledData>
        </StyledDataContainer>
      </StyledBackground>
    </StyledContainer>
  )
}

export default ContactInfo
